<app-breadcrumb [title]="'user'|translate" [items]="['security'|translate]" [active_item]="'user'|translate"></app-breadcrumb>
<div class="container-fluid">
  <div class="edit-profile">
    <form class="row" [formGroup]="userForm" (ngSubmit)="onFormSubmit()" id="ngForm">
      <div class="col-xl-4">
        <div class="card">
          <!--<div class="card-header">
            <h5 class="card-title mb-0 f-w-700">{{ 'picture'|translate }}</h5>

            <ng-template *ngIf="loadForm === false; else isLoadForm"> </ng-template>
            <ng-template #isLoadForm>
              <div class="card-header-right">
                <ul class="list-unstyled card-option">
                  <li><i class="fa fa-spin fa-cog"></i></li>
                </ul>
              </div>
            </ng-template>

            <div class="card-options">
              <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
            </div>
          </div>-->
          <div class="card-body">
            <div>
              <div class="row mb-2">
                <div class="col-auto">
                  <img class="img-70 rounded-circle" alt="" src="{{defaultImg}}" />
                </div>
                <div class="col">
                  <h5 class="mb-1">{{userName}}</h5>
                  <p class="mb-4">{{profileName}}</p>
                </div>
              </div>

              <div class="col-md-12 mb-3">
                <label class="form-label">{{ 'picture'|translate }} </label>
                <input class="form-control form-control-sm" type="file" (change)="onChange($event)" placeholder="Ex. Security" formControlName="file" [ngClass]="{'is-invalid': fc['file'].invalid && isSubmitted}">
                <div class="invalid-feedback" *ngIf="fc['file'].errors?.['serverError']">
                  {{ fc['file'].errors?.['serverError'] }}
                </div>
              </div>

            </div>
          </div>
            <div class="card-footer text-end mb-20"></div>
        </div>
      </div>
      <div class="col-xl-8">
        <div class="card" >
          <!--<div class="card-header">
            <h5 class="card-title mb-0 f-w-700">{{ 'profile'|translate }}</h5>

            <ng-template *ngIf="loadForm === false; else isLoadForm"> </ng-template>
            <ng-template #isLoadForm>
              <div class="card-header-right">
                <ul class="list-unstyled card-option">
                  <li><i class="fa fa-spin fa-cog"></i></li>
                </ul>
              </div>
            </ng-template>

            <div class="card-options">
              <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
            </div>
          </div>-->

            <div class="card-body">

                <div class="row">
              <div class="col-md-4">
                <label class="form-label">{{ 'firstname'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. John" formControlName="firstname" [ngClass]="{'is-invalid': fc['firstname'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['firstname'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['firstname'].errors?.['minlength']">{{ 'firstname must be at least 3 characters long'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['firstname'].errors?.['serverError']">
                  {{ fc['firstname'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{ 'lastname'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. BABA" formControlName="lastname" [ngClass]="{'is-invalid': fc['lastname'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['lastname'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['lastname'].errors?.['minlength']">{{ 'lastname must be at least 3 characters long'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['lastname'].errors?.['serverError']">
                  {{ fc['lastname'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{ 'phone'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="number" placeholder="Ex. 677777777" formControlName="phone" [ngClass]="{'is-invalid': fc['phone'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['phone'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['phone'].errors?.['pattern']">{{ 'phone must between 1 - 9'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['phone'].errors?.['serverError']">
                  {{ fc['phone'].errors?.['serverError'] }}
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-4">
                <label class="form-label">{{ 'username'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. Jdoe" formControlName="username" [ngClass]="{'is-invalid': fc['username'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['username'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['username'].errors?.['serverError']">
                  {{ fc['username'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-8">
                <label class="form-label">{{ 'email'|translate }} </label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. jdoe@bp.com" formControlName="email" [ngClass]="{'is-invalid': fc['email'].invalid && isSubmitted}">

                <small class="invalid-feedback fst-italic" *ngIf="fc['email'].errors?.['email']">{{ 'email must be respect mail convention'|translate }}</small>

                <div class="invalid-feedback" *ngIf="fc['email'].errors?.['serverError']">
                  {{ fc['email'].errors?.['serverError'] }}
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-4">
                <label class="form-label">{{ 'profile'|translate }} <span class="text-danger">*</span></label>
                <ng-select
                        [items]="profiles"
                        bindLabel="name"
                        bindValue="id"
                        placeholder="{{ 'choose a profile'|translate }}"
                        formControlName="profile"
                        [ngClass]="{'is-invalid': fc['profile'].invalid && isSubmitted}"
                        [(ngModel)]="profileSelected">
                </ng-select>
                <div class="invalid-feedback" *ngIf="fc['profile'].errors?.['required']">{{ 'this field is required'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['profile'].errors?.['serverError']">
                  {{ fc['profile'].errors?.['serverError'] }}
                </div>
              </div>
                <div class="col-md-8">
                    <label class="form-label">{{ 'branch'|translate }} <span class="text-danger">*</span></label>
                    <ng-select
                            [items]="branches"
                            bindLabel="name"
                            bindValue="id"
                            placeholder="{{ 'choose a branch'|translate }}"
                            formControlName="branch"
                            [ngClass]="{'is-invalid': fc['branch'].invalid && isSubmitted}"
                            [(ngModel)]="branchSelected">
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="fc['branch'].errors?.['required']">{{ 'this field is required'|translate }}</div>
                    <div class="invalid-feedback" *ngIf="fc['branch'].errors?.['serverError']">
                        {{ fc['branch'].errors?.['serverError'] }}
                    </div>
                </div>
            </div>

    <div class="row mt-3">
        <div class="col-md-4">
            <label class="form-label">{{ 'branch manager ?'|translate }}</label>
            <div class="btn-radio" >
                <div class="btn-group" data-bs-toggle="buttons">
                    <div class="btn btn-light txt-dark">
                        <div class="radio radio-dark">
                            <input id="radio23" formControlName="isNetworkManager" type="radio" value='1'>
                            <label for="radio23">{{ 'yes'|translate }}</label>
                        </div>
                    </div>
                    <div class="btn btn-light txt-dark">
                        <div class="radio radio-dark">
                            <input id="radio24" formControlName="isNetworkManager" type="radio" value='0'>
                            <label for="radio24">{{ 'no'|translate }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <label class="form-label">{{ 'enable ?'|translate }} <span class="text-danger">*</span></label>
            <div class="btn-radio" >
                <div class="btn-group" data-bs-toggle="buttons">
                    <div class="btn btn-light txt-dark">
                        <div class="radio radio-dark">
                            <input id="radio21" formControlName="isEnable" type="radio" value='1'>
                            <label for="radio21">{{ 'yes'|translate }}</label>
                        </div>
                    </div>
                    <div class="btn btn-light txt-dark">
                        <div class="radio radio-dark">
                            <input id="radio22" formControlName="isEnable" type="radio" value='0'>
                            <label for="radio22">{{ 'no'|translate }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

          </div>

          <div class="card-footer text-end">

            <button form="ngForm" (submit)="onFormSubmit()" style="margin-right: 15px;" type="submit" class="btn btn-sm btn-primary m-r-10">
              <i class="fa fa-save" *ngIf="!saving; else isSaving" style="margin-right: 5px;"></i>
              <ng-template #isSaving>
                <i class="fa fa-spin fa-spinner me-2"></i>
              </ng-template>
              {{ 'update'|translate }}
            </button>

              <button  type="button" style="margin-right: 10px;" class="btn btn-sm btn-outline-dark" routerLink='/security/user'>
                  <i class="icofont icofont-ui-close" style="margin-right: 2px;"></i>
                  {{ 'close'|translate }}
              </button>

          </div>
        </div>
      </div>

    </form>
  </div>
</div>